import type { Column, Row } from "@/types/common/data-center";
import { create } from "zustand";

interface DataCenterState {
  id: string;
  name: string;
  description: string;
  columns: Column[];
  rows: Row[];
  selectedIndexes: number[];
  setTableId: (id: string) => void;
  setName: (name: string) => void;
  setDescription: (desc: string) => void;
  addColumn: (col: Column) => void;
  removeColumns: (indexes: number[]) => void;
  addRow: () => void;
  updateCell: (rowIdx: number, colName: string, value: string | number) => void; // NUEVO
  removeRows: (indexes: number[]) => void;
  selectIndex: (index: number) => void;
  deselectIndex: (index: number) => void;
  clearSelection: () => void;
  setColumns: (columns: Column[]) => void;
  setRows: (rows: Row[]) => void;
}

export const useDataCenterStore = create<DataCenterState>((set) => ({
  id: "",
  name: "",
  description: "",
  columns: [],
  rows: [],
  selectedIndexes: [],
  setTableId: (id) => set({ id }),
  setName: (name) => set({ name }),
  setDescription: (description) => set({ description }),
  addColumn: (col) =>
    set((state) => ({
      columns: [...state.columns, col],
    })),
  removeColumns: (indexes) =>
    set((state) => ({
      columns: state.columns.filter((_, idx) => !indexes.includes(idx + 1)),
      selectedIndexes: [],
    })),
  addRow: () =>
    set((state) => ({
      rows: [
        ...state.rows,
        Object.fromEntries(state.columns.map((col) => [col.name])),
      ],
    })),
  updateCell: (rowIdx, colName, value) =>
    set((state) => {
      const newRows = [...state.rows];
      newRows[rowIdx] = { ...newRows[rowIdx], [colName]: value };
      return { rows: newRows };
    }),
  removeRows: (indexes) =>
    set((state) => ({
      rows: state.rows.filter((_, idx) => !indexes.includes(idx + 1)),
      selectedIndexes: [],
    })),
  selectIndex: (index) =>
    set((state) => ({
      selectedIndexes: [...state.selectedIndexes, index],
    })),
  deselectIndex: (index) =>
    set((state) => ({
      selectedIndexes: state.selectedIndexes.filter((i) => i !== index),
    })),
  clearSelection: () => set({ selectedIndexes: [] }),
  setColumns: (columns) => set({ columns }),
  setRows: (rows) => set({ rows }),
}));
